/** Текст EULA (как в приложении). Не заменяет консультацию юриста. */
export const EULA_RU_MARKDOWN = `
# Лицензионное соглашение с конечным пользователем (EULA)

Настоящее соглашение регулирует использование программы «НРИ Плеер» («Программа»).

Правообладатель: Фонтош И.С., физическое лицо.

Используя Программу, устанавливая её, активируя лицензионный ключ или нажимая кнопку принятия условий, пользователь подтверждает, что прочитал и принимает настоящее соглашение.

## 1. Предоставление прав

Правообладатель предоставляет пользователю простую (неисключительную), непередаваемую, ограниченную лицензию на установку и использование Программы в личных некоммерческих целях, связанных с подготовкой и проведением настольных ролевых игр.

Исключительные права на Программу не передаются пользователю. Все права, прямо не предоставленные настоящим соглашением, сохраняются за правообладателем.

## 2. Активация, срок, устройства

Доступ к функциям Программы может предоставляться на основании лицензионного ключа, пробного периода или иного разрешения правообладателя.

Доступные варианты лицензии:

- Базовый ключ: доступ на 1 год, до 3 устройств.
- Ключ мастера: доступ на 2 года, до 5 устройств.
- Легенда НРИ: доступ на 99 лет, до 15 устройств.
- Пробный доступ: предоставляется бесплатно на условиях, указанных правообладателем.

Срок доступа и число устройств определяются выданным лицензионным ключом и отображаются в разделе «О лицензии».

## 3. Поддержка проекта

Пользователь может добровольно поддержать проект. Такая поддержка является добровольным взносом в развитие Программы и не является обязательным условием заключения договора купли-продажи.

В знак благодарности за поддержку проекта правообладатель может вручную предоставить пользователю лицензионный ключ соответствующего уровня доступа. Условия предоставления ключей публикуются правообладателем или сообщаются пользователю отдельно.

## 4. Активация и проверка лицензии

Для активации Программа отправляет на сервер лицензирования лицензионный ключ и технический идентификатор устройства (deviceId). Для проверки отзыва лицензии Программа может отправлять идентификатор лицензии (sub).

Программа не отправляет на сервер имя пользователя, адрес электронной почты, содержимое проектов, сцены, изображения, музыку, заметки, кампании или иные пользовательские материалы.

Лицензионный токен хранится локально на устройстве пользователя с использованием защищённого хранилища операционной системы, если оно доступно.

## 5. Ограничения

Пользователь не вправе:

- передавать, продавать, сдавать в аренду или публиковать лицензионный ключ;
- обходить активацию, технические ограничения или механизмы защиты;
- модифицировать, декомпилировать, дизассемблировать или иным образом пытаться получить исходный код Программы, кроме случаев, прямо разрешённых законом;
- распространять копии Программы от имени правообладателя без разрешения;
- использовать Программу способом, нарушающим законодательство РФ или права третьих лиц.

## 6. Пользовательские материалы

Проекты, сцены, изображения, музыка, тексты и иные материалы, загружаемые пользователем в Программу, остаются у пользователя. Правообладатель не получает прав на такие материалы и не имеет доступа к ним через механизм лицензирования.

Пользователь самостоятельно отвечает за наличие прав на материалы, которые он использует в своих проектах.

## 7. Обновления

Правообладатель может выпускать обновления Программы. Все обновления Программы предоставляются бесплатно, если правообладатель отдельно не объявит иные условия для будущих продуктов или отдельных редакций.

Правообладатель не обязан выпускать обновления в определённые сроки.

## 8. Отзыв и ограничение доступа

Правообладатель вправе отозвать или заблокировать лицензию при нарушении настоящего соглашения, передаче ключа третьим лицам, попытке обхода защиты, злоупотреблении числом устройств или ином недобросовестном использовании.

После отзыва лицензии Программа может ограничить доступ к функциям при наличии сетевого подключения и успешной проверке статуса лицензии.

## 9. Отказ от гарантий

Программа предоставляется «как есть». Правообладатель не гарантирует, что Программа будет работать без ошибок, соответствовать всем ожиданиям пользователя или быть совместимой с любым оборудованием и программным окружением.

Настоящий раздел применяется в пределах, допускаемых законодательством РФ.

## 10. Ограничение ответственности

Правообладатель не несёт ответственности за потерю пользовательских данных, невозможность проведения игры, косвенные убытки, упущенную выгоду или последствия использования пользовательских материалов, если иное прямо не установлено обязательными нормами законодательства РФ.

Ответственность правообладателя в любом случае ограничивается суммой фактически полученной от пользователя поддержки за соответствующий лицензионный ключ, если иное не установлено законом.

## 11. Персональные данные и конфиденциальность

Программа не запрашивает и не передаёт персональные данные пользователя при активации лицензии. Для работы лицензирования используются только технические данные: лицензионный ключ, deviceId, идентификатор лицензии и технические данные сетевого соединения, которые могут автоматически обрабатываться сервером.

Если в будущем Программа или связанные с ней сервисы начнут собирать персональные данные, их обработка будет регулироваться отдельной политикой конфиденциальности.

## 12. Применимое право и споры

К настоящему соглашению применяется право Российской Федерации.

Стороны стремятся решать споры путём переговоров. Если спор не урегулирован, он рассматривается в соответствии с законодательством РФ.

Если пользователь является потребителем, его права, предоставленные императивными нормами законодательства о защите прав потребителей, не ограничиваются настоящим соглашением.

## 13. Изменение соглашения

Правообладатель вправе изменять настоящее соглашение. При существенном изменении условий Программа может запросить повторное принятие новой версии соглашения.

Продолжение использования Программы после принятия новой версии означает согласие пользователя с обновлёнными условиями.
`.trim();
